import React, { useEffect} from 'react';
import "../../styles/Contact.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../../i18n";

const Recapitulatif = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleRedirection = () => {
    navigate("/");
  };

    if(!localStorage.getItem("transactionData")) {
      navigate("/");
    }
  const datar = JSON.parse(localStorage.getItem("transactionData"));


  useEffect(() => {
    if(!localStorage.getItem("transactionData")) {
      
      navigate("/");
    }
    // Remplacer l'état de navigation pour empêcher le retour arrière
    window.history.replaceState(null, "", window.location.href);
   const timeout = setTimeout(() => {
    localStorage.removeItem("transactionData");
  }, 5000);

  // Nettoyer le timeout si le composant est démonté avant les 5 secondes
  return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="recap-container">
      <div className="recap-header">
        <h4 className="recap-title">{t('recap_header.title')}</h4>
        <p className="recap-subtitle">{t('recap_header.subtitle')}</p>
        <a href="https://vodundays.bj/contact/" target="_blank" rel="noopener noreferrer">
          {t('recap_header.subtitlea')}
        </a>
      </div>
      {datar && Object.keys(datar).length > 0 && (
        <div className="recap-section">
          {/* Order Details */}
          <div className="recap-card">
            <h2 className="recap-card-title">{t('order_details.title')}</h2>
            <div className="recap-details">
              <p><strong>{t('order_details.amount_paid')}:</strong> {datar.amount.toLocaleString()} FCFA</p>
              <p><strong>{t('order_details.order_id')}:</strong> {datar.number}</p>
            </div>
          </div>
  
          {/* Invoice Details */}
          <div className="recap-card">
            <h2 className="recap-card-title">{t('invoice.title')}</h2>
            <p className="recap-message">{t('invoice.message')}</p>
            <div className="recap-details">
              <p>
                <a href={datar.invoice.url} target="_blank" rel="noopener noreferrer">
                  {t('invoice.view_invoice')}
                </a>
              </p>
            </div>
          </div>
  
          {/* Tickets Section */}
          {datar.tickets && datar.tickets.length > 0 && (
            <div className="recap-card">
              <h2 className="recap-card-title">{t('tickets.title')}</h2>
              <p className="recap-message">{t('tickets.message')}</p>
              <table className="recap-table">
                <thead>
                  <tr>
                    <th>{t('tickets.ticket')}</th>
                    <th>{t('tickets.links')}</th>
                  </tr>
                </thead>
                <tbody>
                  {datar.tickets.map((ticket, index) => (
                    <tr key={index}>
                      <td>{ticket.name}</td>
                      <td>
                        <a href={ticket.url} target="_blank" rel="noopener noreferrer">
                          {t('tickets.view_ticket')}
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
  
          {/* Tents Section */}
          {datar.tent &&(
            <div className="recap-card">
              <h2 className="recap-card-title">{t('tents.title')}</h2>
              <p className="recap-message">{t('tents.message')}</p>
            </div>
          )}
  
        </div>
      )}
      <button className="btn-home" onClick={handleRedirection}>
        {t('home_button')}
      </button>
    </div>
  );
  
};

export default Recapitulatif;
